import React from 'react';
import Layout from '../components/Layout';

const Terms = () => {
  return (
    <Layout>
      <div className="page">
        <h1>TODO</h1>
      </div>
    </Layout>
  );
};
export default Terms;
